import { useEffect, useState } from "react";
import apiClient from "../../../apiClient";
import useAdditionalData from "../../../components/counter/import/useAdditionalData";
import { useAppContext } from "../../../context";
import { validateAwb } from "../../../utils";
import { Label } from "reactstrap";
import MawbInput from "../../../components/custom/MawbInput";
import moment from "moment";
import _ from "lodash";
import { IscData } from "../../../components/counter/import/interfaces";
import useImportCalc from "./useImportCalc";
import useImportCalc2 from "./useImportCalc2";
import styled from "styled-components";

export default function ImportCalcs() {

    const { user } = useAppContext();
    const [s_mawb, set_s_mawb] = useState('');

    const {
        payments,
        setPayments,
        ffms,
        fhls,
        fwbs,
        locations,
        iscData,
        clearanceData,
        handleSelectFfm,
        stationInfo,
    } = useAdditionalData(
        s_mawb,
        user.s_unit,
        false,
        '',
        'IMPORT'
    );

    // @ts-ignore
    const { importCosts } = useImportCalc(ffms, payments, iscData);

    // @ts-ignore
    const { importCosts: importCosts2 } = useImportCalc2(ffms, payments, iscData);

    return (

        <div>
            <Label>MAWB:</Label>
            <MawbInput
                value={s_mawb}
                onChange={(text) => set_s_mawb(text)}
            />
            <FlexContainer>
                <OuterContainer>
                    {
                        importCosts.map((item, i) => (
                            <Section>
                                <h3>{item.s_flight_id}</h3>
                                <h6>Weight {item.f_weight.toFixed(2)}</h6>
                                <h6>Daily Storage: {item.dailyStorage}</h6>
                                <h6>Storage Days: {item.storageDays}</h6>
                                <h6>Total Storage: {item.totalStorage}</h6>
                                <br></br>
                            </Section>
                        ))
                    }
                </OuterContainer>
                <OuterContainer>
                    {
                        importCosts2.map((item, i) => (
                            <Section>
                                <h3>{item.s_flight_id}</h3>
                                <h6>Weight {item.f_weight.toFixed(2)}</h6>
                                <h6>Daily Storage: {item.dailyStorage}</h6>
                                <h6>Storage Days: {item.storageDays}</h6>
                                <h6>Total Storage: {item.totalStorage}</h6>
                                <br></br>
                            </Section>
                        ))
                    }
                </OuterContainer>
            </FlexContainer>
        </div>
    );
}

const FlexContainer = styled.div`
    display: flex;
    gap: 200px;
    margin-top: 10px;
`;

const OuterContainer = styled.div`
    border: 1px solid black;
    border-radius: 10px;
    padding: 20px;
`;

const Section = styled.div`
    margin: 10px 0px;

    & h3 {
        font-weight: bold;
    }
`;